'use client';

import { useFormContext, useWatch } from 'react-hook-form';
import { ClearableInput } from '@/shared/ui/kit/clearable-input';
import { ProfileFormData } from '@/shared/lib/validation/registration-wizard/profile';


export const UserProfileFields = () => {
    const { register, control, formState: { errors }, setValue, clearErrors } = useFormContext<ProfileFormData>();
    const [ firstName, lastName, jobTitle, phone ] = useWatch({
        control,
        name: [ 'first_name', 'last_name', 'job_title', 'phone' ],
    });

    return (
        <>
            <ClearableInput
                label="First name"
                placeholder="Enter first name"
                autoComplete="given-name"
                error={ errors.first_name?.message }
                required
                value={ firstName }
                onClear={ () => setValue('first_name', '', { shouldValidate: true }) }
                { ...register('first_name') }
                onFocus={ () => clearErrors('first_name') }
            />

            <ClearableInput
                label="Last name"
                placeholder="Enter last name"
                autoComplete="family-name"
                error={ errors.last_name?.message }
                required
                value={ lastName }
                onClear={ () => setValue('last_name', '', { shouldValidate: true }) }
                { ...register('last_name') }
                onFocus={ () => clearErrors('last_name') }
            />

            <ClearableInput
                label="Job title"
                placeholder="Enter job title"
                error={ errors.job_title?.message }
                required
                value={ jobTitle }
                onClear={ () => setValue('job_title', '', { shouldValidate: true }) }
                { ...register('job_title') }
                onFocus={ () => clearErrors('job_title') }
            />

            <ClearableInput
                label="Phone number"
                type="tel"
                placeholder="Enter phone number"
                autoComplete="mobile tel"
                error={ errors.phone?.message }
                required
                value={ phone }
                onClear={ () => setValue('phone', '', { shouldValidate: true }) }
                { ...register('phone') }
                onFocus={ () => clearErrors('phone') }
            />
        </>
    );
};
